<template>
  <div class="container">
    <div class="layout">
      <div id="wp_news_w7">
        <div
          class="pic"
          :style="'background:url('+ obj.articleCoverUrl +') no-repeat center center / contain;'"
        ></div>
        <a target="_blank" :title="obj.articleTitle" @click="toDeatil(obj)">
          {{ obj.articleTitle }}
        </a>
      </div>
      <div class="info" v-for="(it) in list" :key="it.articleTypeId" >
        <div class="ewp_news_w2">
          <!-- <div class="title clearfix">
            <p frag="标题">{{ it.title }}</p>
            <span frag="按钮" type="更多" @click="tomore(it)">
              <a class="w3_more"><span frag="按钮内容">更多</span></a>
            </span>
          </div> -->
          <ul>
            <li v-for="article in it.artcleList.slice(1)" :key="article.id">
              <img src="@/assets/img/icon.png" alt="" />
              <a
                target="_blank"
                :title="article.articleTitle"
                @click="toDeatil(article)"
                >{{ article.articleTitle }}</a
              >
              <span>{{ article.createTime | dateFilters }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// window.addEventListener('message', handleMessage,false)
// function handleMessage(e) {
//   if (e.data.status === "articleMsg-ok") {
//     console.log(e.data.params.articleTypeId); //文章类型id
//     console.log(e.data.params.articleTypeTitle); // 文章类型名称
//     console.log(e.data.params.artilceId); // 文章id
//   }
// }
import { dateFormat } from "@/utils";
import { getList, articleDetail } from "@/api/article";
export default {
  name: "index",
  components: {},
  data() {
    return {
      list: [
        {
          title: "医疗动态",
          articleTypeId: 109,
          artcleList: [],
        },
      ],
      obj: {},
    };
  },
  computed: {},
  filters: {
    dateFilters(data) {
      return dateFormat("yyyy-MM-dd", new Date(data));
    },
  },
  created() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      this.list.forEach(async (item, index) => {
        const { code, data } = await getList({
          articleTypeId: item.articleTypeId,
          pageNum: 1, //页码 默认为1
          pageSize: 6, //每页记录数 默认为10
        });
        if (code == 200) {
          this.obj = data[0];
          this.list[index].artcleList = data;
        }
      });
    },
    tomore(data) {
      window.parent.postMessage(
        {
          status: "articleMsg-ok",
          params: {
            articleTypeId: data.articleTypeId,
            articleTypeTitle: data.title,
          },
        },
        "*"
      );

      // this.$router.push({
      //   path: "/listPage",
      //   query: {
      //     articleTypeId: data.articleTypeId,
      //     articleTypeTitle: data.title,
      //   },
      // });
    },
    async toDeatil(article) {
      if (article.isOuterChain == 0) {
        //外链
        window.open(article.articleContent);
      } else {
      window.parent.postMessage(
        {
          status: "articleMsg-ok",
          params: {
            artilceId: article.id,
          },
        },
        "*"
      );
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: {
          artilceId: article.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    }
      // this.$router.push({
      //   path: "/detail",
      //   query: {
      //     artilceId: article.id,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 255px;
  overflow: hidden;
  background-color: #fcfcfc;
}
#wp_news_w7 {
  width: 337px;
  height: 250px;
  position: relative;
  // margin-top: 15px;
  .pic {
    width: 100%;
    height: 250px;
  }
  a {
    // width: 329px;
    height: 42px;
    position: absolute;
    bottom: 0;
    left: 0;
    margin-top: 9px;
    padding-left: 8px;
    line-height: 42px;
    color: #fff;
    font-size: 16px;
    background-color: #003f88;
    background-color: rgba(0, 63, 136, 0.8);
  }
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  .title {
    width: 100%;
    position: relative;
    margin-top: 30px;
    p {
      margin: 0px;
      padding: 0px;
      height: 40px;
      position: relative;
      font: 24px/40px "microsoft yahei";
      color: #333;
      cursor: pointer;
    }
    .w3_more {
      text-decoration: none !important;
      height: 28px;
      display: block;
      padding: 0 15px;
      position: absolute;
      right: 0;
      top: 5px;
      line-height: 28px;
      font-size: 14px;
      border: 1px solid #9a9a9a;
      color: #9a9a9a;
    }
  }
  .info {
    font-size: 16px;
    color: #333;
    margin: 0;
    padding: 0px;
    float: left;
    width: 405px;
    position: relative;
  }
  .ewp_news_w2 {
    ul {
      li {
        position: relative;
        --antd-wave-shadow-color: #1890ff;
        -webkit-text-size-adjust: 100%;
        font-variant: tabular-nums;
        line-height: 1.5;
        font-feature-settings: "tnum";
        font-family: "Microsoft Yahei", "微软雅黑", "宋体", arial,
          "Hiragino Sans GB", Tahoma, Arial, Helvetica;
        color: #333;
        margin: 0;
        padding: 0;
        font-size: 12px;
        box-sizing: border-box;
        border: none;
        -webkit-tap-highlight-color: transparent;
        list-style: none;
        border-bottom: 1px dashed #ececec;
        img {
          font-size: 16px;
          color: #333;
          list-style: none;
          line-height: 50px;
          vertical-align: middle;
          outline: none;
          border: 0;
          position: absolute;
          left: 8px;
          top: 18px;
          margin-right: 10px;
        }
        a {
          font-family: "microsoft yahei";
          list-style: none;
          line-height: 50px;
          color: #333;
          text-decoration: none !important;
          display: block;
          width: 100%;
          box-sizing: border-box;
          padding: 0 90px 0 20px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          list-style: none;
          line-height: 50px;
          position: absolute;
          right: 8px !important;
          top: 0 !important;
          color: #999;
          font-size: 14px;
          background-color: transparent !important;
        }
      }
    }
  }
}
</style>
